import { CONFIG } from '../../../core/config';
import { ViewModel } from '../../view-model';
import { HierarchyTemplateAttribute } from '../hierarchy-templates/hierarchy-template-attribute';
import { TableTemplateColumn } from './table-template-column';

export class TableTemplate implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Table Template';
  public readonly apiRoute: string = CONFIG.apiRoutes.tableAttributeTemplate;

  public tableTemplateId: string;
  public hierarchyTemplateAttributeId: string;
  public name: string;
  public description: string;
  public tableTemplateColumns: TableTemplateColumn[] = [];
  public hierarchyTemplateAttribute: HierarchyTemplateAttribute;

  public json(): this {
    return this;
  }

  public loadFromJson(data: any): void {

    this.tableTemplateId = data.tableTemplateId;
    this.hierarchyTemplateAttributeId = data.hierarchyTemplateAttributeId;
    this.name = data.name;
    this.description = data.description;

    if (data.tableTemplateColumns) {
      data.tableTemplateColumns.forEach(col => {
        const newCol = new TableTemplateColumn();

        newCol.loadFromJson(col);
        this.tableTemplateColumns.push(newCol);
      });
    }

  }
}
